import { SortIcon } from "components/Table_SortColumnIcon"

const ordersListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, order) => <>{order.id}</>,
    },
    {
      text: "Date/Time",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => <>{order.created_at}</>,
    },
    {
      text: "User",
      dataField: "first_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => (
        <>
          {order?.first_name} {order?.last_name}
        </>
      ),
    },
    {
      text: "User Email",
      dataField: "email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => <>{order.email}</>,
    },
    {
      text: "Product",
      dataField: "product_name",
      sort: true,
      style: () => ({ whiteSpace: "normal" }),
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => <>{order.product_name}</>,
    },
    {
      text: "Price",
      dataField: "amount",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => <>${order?.amount / 100}</>,
    },
    {
      text: "Status",
      dataField: "string_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => <>{order.string_status}</>,
    },
    {
      text: "User Status",
      dataField: "user_status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, order) => (
        <>
          {order.user_status === 1 && "Existing"}
          {order.user_status === 2 && "New"}
        </>
      ),
    },
  ]
}

export default ordersListColumns
